import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { Spinner } from '../components/UI';

export default function ImportarFixed() {
  const [archivo, setArchivo] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [error, setError] = useState('');
  const [ultimaFecha, setUltimaFecha] = useState(null);

  useEffect(() => {
    api('/importar/fixed/ultima-importacion').then(res => setUltimaFecha(res.ultima_fecha));
  }, []);

  const diasDesdeUltima = () => {
    if (!ultimaFecha) return null;
    const dias = Math.floor((new Date() - new Date(ultimaFecha)) / (1000 * 60 * 60 * 24));
    return dias;
  };

  const dias = diasDesdeUltima();

  const subir = async () => {
    if (!archivo) return;
    setSubiendo(true); setError(''); setResultado(null);
    try {
      const formData = new FormData();
      formData.append('file', archivo);
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/importar/importar-fixed-xml', {
        method: 'POST', body: formData,
      });
      if (!res.ok) throw new Error('Error al procesar el archivo');
      const data = await res.json();
      setResultado(data);
      setUltimaFecha(new Date().toISOString());
    } catch (e) {
      setError(e.message);
    }
    setSubiendo(false);
  };

  return (
    <div className="page-content">
      <h1 className="page-title">Importar facturas de Fixed</h1>

      {dias !== null && dias >= 10 && (
        <div className="card" style={{ marginBottom: '1rem', background: '#fff3e0', borderLeft: '3px solid #b45309' }}>
          <p style={{ color: '#92400e', fontSize: '.875rem' }}>
            ⚠️ Hace {dias} días que no importás facturas de Fixed. Conviene actualizarlo para mantener los costos al día.
          </p>
        </div>
      )}
      {dias !== null && dias < 10 && (
        <p style={{ color: 'var(--gris-4)', fontSize: '.875rem', marginBottom: '1rem' }}>
          Última importación: hace {dias} día(s).
        </p>
      )}

      <div className="card" style={{ marginBottom: '1rem' }}>
        <p style={{ fontWeight: 600, marginBottom: '.6rem', color: 'var(--azul)' }}>Cómo exportar desde Fixed</p>
        <ol style={{ fontSize: '.875rem', color: 'var(--gris-5)', lineHeight: 1.8, paddingLeft: '1.2rem' }}>
          <li>Entrá a Fixed → CFE Recibidos</li>
          <li>Hacé clic en "Exportar listado actual de CFEs Recibidos (XML)"</li>
          <li>Subí ese archivo aquí abajo</li>
        </ol>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <input type="file" accept=".xml" onChange={e => setArchivo(e.target.files[0])}
          style={{ marginBottom: '.75rem' }} />
        <button className="btn btn-primary btn-full" disabled={!archivo || subiendo} onClick={subir}>
          {subiendo ? 'Procesando...' : 'Importar archivo'}
        </button>
        {subiendo && <Spinner texto="Leyendo XML..." />}
        {error && <p style={{ color: 'var(--rojo)', fontSize: '.875rem', marginTop: '.5rem' }}>{error}</p>}
      </div>

      {resultado && (
        <div className="card">
          <p style={{ fontWeight: 600, color: 'var(--verde)', marginBottom: '.6rem' }}>
            ✅ Se encontraron {resultado.items_encontrados} repuestos/productos
          </p>
          <div className="tabla-wrap">
            <table className="tabla">
              <thead><tr><th>Nombre</th><th>Código</th><th>Proveedor</th><th>Precio</th></tr></thead>
              <tbody>
                {resultado.items.map((it, i) => (
                  <tr key={i}>
                    <td>{it.nombre}</td>
                    <td>{it.codigo || '—'}</td>
                    <td>{it.proveedor || '—'}</td>
                    <td>${it.precio?.toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
